import {css} from "styled-components"

/** @author: Richard 16/3/2018
 *  @desc: BreakWord for all browsers.
    - break-all (Supported by all)
    - -ms-* for IE
    - break-word for proper browsers
 */
export const breakWord = css`
  -ms-word-wrap: break-word;
  word-break: break-word;
`


export default {
  breakWord
}
